import React from 'react';
import { ServiceItem } from './ServiceItem';

export interface IService {
  title: string;
  img: string;
  content: string;
}

interface IProps {
  services: Array<IService>;
}

export class Services extends React.Component<IProps> {
  render() {
    return (
      <div id="services">
        <div className="section-white">
          <div className="container">
            <div className="row margin-bottom-50">
              <div className="col-md-12 text-center">
                <h2 className="section-title">Why iSlide?</h2>
                <div className="separator_wrapper">
                  <span
                    className="glyphicon glyphicon-star star"
                    aria-hidden="true"
                  ></span>
                </div>
              </div>
            </div>
            <div className="row">
              {this.props.services.map((service, i) => (
                <ServiceItem
                  title={service.title}
                  img={service.img}
                  content={service.content}
                  key={i}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Services;
